import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { RobotMascot } from '@/components/core/ThemeMascot/mascots';

export const robotTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.ROBOT,
  hover: {
    transform: 'translateY(-4px)',
    transition: 'transform 0.15s steps(3)',
  },
  click: {
    transform: 'scale(0.94)',
    transition: 'transform 0.08s steps(2)',
  },
  idle: {
    animationName: 'playful-robot-glitch',
    animationDuration: '3s',
    animationTimingFunction: 'steps(8)',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.04) translateY(-2px)',
    transition: 'transform 0.1s steps(2)',
  },
  particles: {
    enabled: true,
    count: 5,
    characters: ['⚡', '🔧', '⚙️', '🤖'],
    spread: 40,
    duration: 800,
    size: 14,
  },
  keyframes: [
    {
      name: 'playful-robot-glitch',
      css: `@keyframes playful-robot-glitch {
  0%, 100% { transform: translate(0, 0); }
  10% { transform: translate(-1px, 0); }
  20% { transform: translate(1px, -1px); }
  30% { transform: translate(0, 0); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/buzz', volume: 0.12 },
    click: { name: 'arcade/power_up', volume: 0.2, rate: 1.2 },
  },
  metadata: {
    label: 'Robot',
    icon: IconName.SETTINGS,
    previewEmoji: '🤖',
    description: 'Mechanical precision',
    mascotEmoji: '🤖',
    mascotComponent: RobotMascot,
  },
};
